<template>
  <div class="page">
    <SubHeader :page="pageName"></SubHeader>

    <div v-if="!allLogosLoaded" class="loading-overlay">
      <i class="fa fa-spinner fa-spin"></i>
    </div>

    <div v-if="allLogosLoaded" class="inputs">
      <div class="category-filter">
        <span v-for="(option, index) in categoryOptions" :key="index" v-on:click="selectedCategory = option" :class="option === selectedCategory ? 'selected-class' : ''">
          {{ option }}
        </span>
      </div>
    </div>

    <div v-show="allLogosLoaded" class="retailer-cart-logos" v-if="cartsToShow && cartsToShow.length > 0">
      <transition-group name="fade">
        <div class="cart-info" v-for="cart in cartsToShow" :key="cart.cartName">
          <img @load="incrementLoadedCount()" :src="cart.cartLogo" onerror="this.style.display='none'" :alt="`${cart.cartName} Logo`">
        </div>
      </transition-group>

      <div class="retailer-carts-footer block-heading-font-style" :style="noMatchesFound ? 'display: none' : '' ">Leverage these retailers plus hundreds more!</div>

    </div>

    <span v-if="noMatchesFound && allLogosLoaded" class="retailer-cart-logos" style="color: red; padding: 20px 0 40px 0; font-size: 24px;"> No matches were found. Please refine your search. </span>

  </div>
</template>

<script>

import { mapState } from 'vuex'
import SubHeader from './common/SubHeader'

export default {
  async mounted() {
    const res = await fetch('https://attach-videos.s3.amazonaws.com/cartsInfo.json')
    const resData = await res.json()
    const carts = this.cleanCartData(resData)

    this.$store.commit('setCartList', carts)
  },
  data() {
    return {
      allLogosLoaded: false,
      loadedCount: 0,
      selectedCategory: 'All',
      pageName: 'Retail Partners',
      internationalPartners: [
        'Adidas France',
        'Adidas Germany',
        'Adidas UK',
        'Amazon Canada',
        'Amazon Germany',
        'Amazon Spain',
        'Amazon UK',
        'Lancome UK',
        'Nars UK',
        'Walmart Canada'
      ]
    }
  },
  components: {
    SubHeader
  },
  methods: {
    cleanCartData(data) {
      let carts = []

      for (let cartId in data) {
        if (data[cartId].cartLogo) carts.push(data[cartId])
      }
      carts = this.alphabetizeCarts(carts)

      return carts || []
    },
    incrementLoadedCount() {
      let minLoadCount = this.$store.state.cartList.length - this.internationalPartners.length
      if (this.loadedCount >=  minLoadCount - 1) {
        this.allLogosLoaded = true
        return
      }

      this.loadedCount++
    },
    alphabetizeCarts(carts = []) {
      return carts.sort((a, b) => {
        let nameA = a.cartName.toUpperCase()
        let nameB = b.cartName.toUpperCase()

        if (nameA < nameB) return -1
        if (nameA > nameB) return 1

        // names must be equal
        return 0
      })
    }
  },
  computed: {
    ...mapState([
      'cartList'
    ]),
    cartsToShow() {
      let filteredCarts = [...this.cartList]

      if (this.selectedCategory) {
        if (this.selectedCategory !== 'All') {
          if (this.selectedCategory === 'International') {
            filteredCarts = filteredCarts.filter(cart => this.internationalPartners.indexOf(cart.cartName) !== -1)
          } else {
            filteredCarts = filteredCarts.filter(cart => cart.cartCategory === this.selectedCategory && this.internationalPartners.indexOf(cart.cartName) === -1)
          }
        } else {
          filteredCarts = filteredCarts.filter(cart => this.internationalPartners.indexOf(cart.cartName) === -1)
        }
      }

      return filteredCarts
    },
    categoryOptions() {
      const options = []

      this.cartList.forEach(({ cartCategory }) => {
        if (cartCategory && options.indexOf(cartCategory) === -1) options.push(cartCategory)
      })

      options.sort()
      options.unshift('All')
      options.push('International')

      return options
    },
    noMatchesFound() {
      return this.cartsToShow && this.cartsToShow.length === 0
    }
  },
  watch: {}
}
</script>

<style scoped>

  .retailer-carts-footer {
    text-transform: none;
    margin-top: 20px;
    font-size: 24px;
    padding: 24px;
  }

  .retailer-cart-logos {
    display: block;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    margin-top: 24px;
    font-size: 12px;
    max-width: 800px;
    transition: ease-in-out 3.0s;
  }

  @media only screen and (max-width: 900px) {
    .retailer-cart-logos {
      width: 90%;
    }
  }

  .cart-info {
    display: inline-block;
    margin: 16px;
  }

  .cart-info img {
    width: 124px;
  }

  @media only screen and (max-width: 900px) {
    .cart-info {
      display: inline-block;
      margin: 12px;
    }

    .cart-info img {
      width: 100px;
    }
  }

  @media only screen and (max-width: 900px) {
    .category-filter {
      display: none;
    }
  }

  .loading-overlay {
    text-align: center;
    height: 700px;
  }

  .fa-spin {
    margin: 20%;
    opacity: 0.4;
    font-size: 32px;
  }

  .inputs {
    display: flex;
    justify-content: space-evenly;
    margin-top: 25px;
  }

  .category-filter {
    font-size: 16px;
    color: #3dbbb7;
    font-weight: 700;
    margin-left: 13%;
    width: 60%;
  }

  .category-filter {
    font-size: 16px;
    color: #3dbbb7;
    font-weight: normal;
    width: 100%;
    text-align: center;
    font-family: "Work Sans", sans-serif;
    cursor: pointer;
    margin: 0 auto;
  }

  .category-filter span {
    margin: 0 8px;
  }

  ::-webkit-input-placeholder { /* Edge */
    color: lightgray;
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: lightgray;
  }

  ::placeholder {
    color: lightgray;
  }

  .selected-class {
    cursor: none;
    color: #333;
    text-decoration: underline;
  }

  .fade-enter-active {
    transition: opacity .5s ease-in-out;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fade-enter {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// RetailPartners.vue?75470f1c